// WHO adaptation notice for INN-derived content (Plan decision Q10). Verbatim; do not edit.
export const WHO_INN_DISCLAIMER =
  'This adaptation was not created by WHO. WHO is not responsible for the content or accuracy of this adaptation. The original edition shall be the binding and authentic edition.';
